export default "__VITE_ASSET__Bm_FHr2c__"